import { FiTrash2, FiArrowRight, FiDownload } from "react-icons/fi";
import Search from "./Search";

export default function Header({
  selected,
  setShowJumpToPop,
  setShowPop,
  setSearch,
  setPage,
  getSelectState,
  exportState,
}) {
  const disabled = !selected;
  const { username, role } = JSON.parse(localStorage.getItem("profile")).value[0];

  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-5">

      {/* Row 1: Search */}
      <div className="flex flex-col sm:flex-row gap-4 mb-4 items-start sm:items-center">
        <div className="flex-1">
          <Search setSearch={setSearch} setPage={setPage} />
        </div>
      </div>

      {/* Row 2: Action buttons */}
      <div className="flex flex-wrap gap-2 mb-0">
        <button
          type="button"
          disabled={disabled}
          onClick={() => setShowPop(true)}
          className="flex items-center gap-2 bg-red-600 hover:bg-red-500 disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors"
        >
          <FiTrash2 size={14} /> Delete
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={() => setShowJumpToPop(true)}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 disabled:opacity-40 disabled:cursor-not-allowed text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors"
        >
          <FiArrowRight size={14} /> Jump To State
        </button>
      </div>

      {/* Row 3: Export (admin and auditor only) */}
      {(role === "admin" || role === "auditor") && (
        <div className="flex flex-wrap items-end gap-3 mt-4 pt-4 border-t border-white/10">
          <div>
            <label className="text-slate-400 text-xs font-semibold uppercase tracking-widest mb-2 block" htmlFor="states">
              Export by State
            </label>
            <select
              onChange={(e) => getSelectState(e.target.value)}
              className="bg-slate-800 border border-slate-600 text-white text-sm rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              id="states"
            >
              <option value="all">All</option>
              <option value="auditing">Auditing</option>
              <option value="auditing_pending">Auditing Pending</option>
              <option value="invoice">Invoice</option>
              <option value="invoice_wait">Invoice Wait</option>
              <option value="another_invoice">Another Invoice</option>
              <option value="request_edit">Request Edit</option>
              <option value="score_validation">Score Validation</option>
              <option value="score_request">Score Request</option>
              <option value="score_pending">Score Pending</option>
              <option value="mohe_validation">MOHE Validation</option>
              <option value="mohe">MOHE</option>
              <option value="done">Done</option>
            </select>
          </div>
          <button
            type="button"
            onClick={exportState}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors shadow"
          >
            <FiDownload size={14} /> Export
          </button>
        </div>
      )}
    </div>
  );
}
